const FILE_LOCATION = 'content';
const TEST_FILE_LOCATION = 'test/content';
const TEMP_FILE_NAME = 'temp';
export {FILE_LOCATION, TEST_FILE_LOCATION, TEMP_FILE_NAME};
